import React, { useState, useCallback } from 'react';
import { Routes, Route } from 'react-router-dom';
import OwcDrawerLayout from '../components/Sidebar/OwcDrawer';
import MoveToTop from '../components/Common/MoveToTop';
import { useGroupData } from '../contexts/GroupDataContext';
import { DASHBOARD_ROUTES } from '../config/uiConfig';
import { resolveComponent } from '../config/componentRegistry';

function DashboardRouteContent() {
  return (
    <Routes>
      {DASHBOARD_ROUTES.map(({ path, component }) => {
        const Component = resolveComponent(component);
        return <Route key={path} path={path} element={Component ? <Component /> : null} />;
      })}
    </Routes>
  );
}

function DashboardPage() {
  const [drawerVisible, setDrawerVisible] = useState(true);
  const { appDisabled } = useGroupData();
  const toggleDrawer = useCallback(() => setDrawerVisible((prev) => !prev), []);

  return (
    <div className="flex flex-col min-h-screen" style={{ height: '100%' }}>
      <div className={`flex-1 ${appDisabled ? 'app-disabled' : ''}`} style={{ height: '100%' }}>
        <OwcDrawerLayout drawerVisible={drawerVisible} toggleDrawer={toggleDrawer}>
          <DashboardRouteContent />
        </OwcDrawerLayout>
      </div>
      <MoveToTop />
    </div>
  );
}

export default DashboardPage;
